import React from "react";
import SmartLink from "components/SmartLink";

import styles from "./DetailsSection.module.scss";
import SectionWrapper from "components/elements/SectionWrapper";

import DetailList from "components/elements/DetailList/DetailList";
import FeatureDetailList from "components/elements/FeatureDetailList/FeatureDetailList";
import SimpleFeatureList from "components/elements/SimpleFeatureList/SimpleFeatureList";

const DetailsSection = (props) => {
	const { cta_text, cta_link, view } = props;
	return (
		<SectionWrapper
			className={`${styles.DetailsSection}`}
			fluid={false}
			{...props}>
			{view?.id === 1 ? (
				<SimpleFeatureList {...props}/>
			) : view?.id === 2 ? (
				<FeatureDetailList {...props}/>
			) : (
				<DetailList {...props}/>
			)}
			
			{cta_text && cta_link && (
				<SmartLink
					to={cta_link}
					className="btn btn-lg btn-light text-uppercase">
					{cta_text}
				</SmartLink>
			)}
		</SectionWrapper>
	);
};

export default DetailsSection;
